// Copyright 2019 Amplify Inc. All Rights Reserved.

/**
 * @fileoverview Default configuration options. These will be used unless overridden by a client.
 * @author jgraham@amplify.com (Jessica Graham)
 */
'use strict';

var _defaultConfig, _defaultTrackingConfi, _defaultSearchTrackin;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _require = require('../constants/config-options'),
    CONFIG_OPTIONS = _require.CONFIG_OPTIONS,
    TRACKING_OPTIONS = _require.TRACKING_OPTIONS,
    LINK_TRACKING_OPTIONS = _require.LINK_TRACKING_OPTIONS,
    SEARCH_TRACKING_OPTIONS = _require.SEARCH_TRACKING_OPTIONS;

var defaultConfig = (_defaultConfig = {}, _defineProperty(_defaultConfig, CONFIG_OPTIONS.LANGUAGE, 'en-US'), _defineProperty(_defaultConfig, CONFIG_OPTIONS.HOMEPAGE, 'https://my.amplify.com'), _defineProperty(_defaultConfig, CONFIG_OPTIONS.SEND_EVENTS_IMMEDIATELY, false), _defaultConfig);
var defaultTrackingConfig = (_defaultTrackingConfi = {}, _defineProperty(_defaultTrackingConfi, TRACKING_OPTIONS.AUTO_UNLOAD, true), _defineProperty(_defaultTrackingConfi, TRACKING_OPTIONS.TRACK_APP_LOAD, true), _defineProperty(_defaultTrackingConfi, TRACKING_OPTIONS.TRACK_APP_UNLOAD, true), _defineProperty(_defaultTrackingConfi, TRACKING_OPTIONS.STASH_APP_UNLOAD_EVENT, true), _defineProperty(_defaultTrackingConfi, TRACKING_OPTIONS.TRACK_PAGE_VIEW, true), _defineProperty(_defaultTrackingConfi, TRACKING_OPTIONS.TRACK_PAGE_CLOSE, false), _defineProperty(_defaultTrackingConfi, TRACKING_OPTIONS.STASH_FINAL_PAGE_CLOSE_EVENT, true), _defineProperty(_defaultTrackingConfi, TRACKING_OPTIONS.TRACK_PAGES_BY_HASH_CHANGE, false), _defaultTrackingConfi);

var defaultLinkTrackingConfig = _defineProperty({}, LINK_TRACKING_OPTIONS.TRACK_DOWNLOADS, false);

var defaultSearchTrackingConfig = (_defaultSearchTrackin = {}, _defineProperty(_defaultSearchTrackin, SEARCH_TRACKING_OPTIONS.INITIALIZE_SEARCH_LISTENER, null), _defineProperty(_defaultSearchTrackin, SEARCH_TRACKING_OPTIONS.STOP_SEARCH_LISTENER, null), _defaultSearchTrackin);
module.exports = {
  defaultConfig: defaultConfig,
  defaultTrackingConfig: defaultTrackingConfig,
  defaultLinkTrackingConfig: defaultLinkTrackingConfig,
  defaultSearchTrackingConfig: defaultSearchTrackingConfig
};